export default class ResourceUtils {
    public static predefinedSubjectsList: any = [
        {
            colour: "#486CD8",
            subjectID: 8337,
            name: "Science",
        },
        {
            colour: "#6A1B9A",
            subjectID: 3026,
            name: "Social Studies",
        },
        {
            colour: "#B2528C",
            subjectID: 1184,
            name: "Mathematics",
        },
        {
            colour: "#D6383A",
            subjectID: 1880,
            name: "English Language Arts and Literacy",
        },
        {
            colour: "#262626",
            subjectID: 8353,
            name: "Engineering & Technology",
        },
        {
            colour: "#087B45",
            subjectID: 2806,
            name: "Health and Physical Education",
        },
        {
            colour: "#007B9B",
            subjectID: 2949,
            name: "Preschool",
        },
        {
            colour: "#60738A",
            subjectID: 6708,
            name: "Professional Development",
        },
        {
            colour: "#074D51",
            subjectID: 2663,
            name: "The Arts",
        },
        {
            colour: "#A31A51",
            subjectID: 6267,
            name: "World Languages",
        },
    ]

    private static allGrades: object = {
        PreK: 1,
        K: 2,
        1: 3,
        2: 4,
        3: 5,
        4: 6,
        5: 7,
        6: 8,
        7: 9,
        8: 10,
        9: 11,
        10: 12,
        11: 13,
        12: 14,
        "13+": 15,
    }

    static getGradesLabel(gradesText): string {
        if (!gradesText) {
            return ""
        }
        if (gradesText.indexOf("-") === -1 && gradesText.indexOf(",") === -1) {
            return "Grade"
        }
        return "Grades"
    }

    public static getGradeRangesDisplay(grades: string[]): string {
        if (grades.length == 0) {
            return ""
        }

        const sortedGrades = grades.sort((a, b) => this.allGrades[a] - this.allGrades[b])
        let gradeRange = sortedGrades[0]
        let refGrade = sortedGrades[0]
        let prevGrade = sortedGrades[0]
        for (const gr of sortedGrades.slice(1)) {
            if (this.allGrades[gr] > this.allGrades[prevGrade] + 1) {
                if (this.allGrades[prevGrade] > this.allGrades[refGrade]) {
                    gradeRange += "-" + prevGrade + ", " + gr
                } else {
                    gradeRange += ", " + gr
                }
                refGrade = gr
            }
            prevGrade = gr
        }
        if (prevGrade !== refGrade) {
            gradeRange += "-" + prevGrade
        }

        return gradeRange
    }

    public static getMediaTypesDisplay(mediaTypes: { [mediaType: string]: number }): string {
        return Object.keys(mediaTypes)
            .map((mediaType) => `${mediaType} (${mediaTypes[mediaType]})`)
            .join(", ")
    }

    public static getResourcesByLanguage(languages: { [language: string]: number }): string {
        let resByLanguageText = Object.keys(languages)
            .map((language) => `Resources in ${language} (${languages[language]})`)
            .join(", ")
        return resByLanguageText ? ", " + resByLanguageText : ""
    }

    public static getResourceTypesDisplay(
        mediaTypes: { [mediaType: string]: number },
        grades: string[],
        resources_by_language: { [language: string]: number }
    ): string {
        let displayText = ""
        const mediaDisplay = ResourceUtils.getMediaTypesDisplay(mediaTypes)
        const gradeDisplay = ResourceUtils.getGradeRangesDisplay(grades)
        const gradesLabel = ResourceUtils.getGradesLabel(gradeDisplay)
        if (mediaDisplay && gradeDisplay) {
            displayText = `${mediaDisplay} for ${gradesLabel} ${gradeDisplay}`
        }
        const resourcesByLanguage = ResourceUtils.getResourcesByLanguage(resources_by_language)
        if (resourcesByLanguage) {
            displayText = displayText + resourcesByLanguage
        }
        return displayText
    }

    public static getPremiumCollectionSlug() {
        if (window.location.href.split("/").length != 8) {
            return "" // False
        } else {
            return window.location.href.split("/").reverse().slice(1,2).toString()
        }
    }
}
